import React from "react"
import {useWatch} from "react-hook-form"

import {FIconColorPicker, FormInput, FTextArea} from "@components/form"
import {FieldType} from "@components/types"

const fields: FieldType = {
    icon: {
        parentField: "info",
        field: "icon",
        label: "Icon",
        rules: {
            required: "Game icon is required"
        }
    },
    color: {
        parentField: "info",
        field: "color",
        label: "Color",
        rules: {
            required: "Game color is required"
        }
    },
    title: {
        parentField: "info",
        field: "title",
        label: "Title",
        rules: {
            required: "Game title is required"
        }
    },
    description: {
        parentField: "info",
        field: "description",
        label: "Description",
        rules: {
            required: "Game description is required"
        }
    }
}

type GameInfoProps = {
    register: any,
    errors: any,
    setValue: (name: string, value: unknown, config?: Object) => void,
    control: any
}

export function GameInfo(props: GameInfoProps) {

    const {register, errors, setValue, control} = props

    const iconField = fields.icon.parentField ? `${fields.icon.parentField}.${fields.icon.field}` : fields.icon.field
    const colorField = fields.color.parentField ? `${fields.color.parentField}.${fields.color.field}` : fields.color.field

    const watchIcon = useWatch({name: iconField, control})
    const watchColor = useWatch({name: colorField, control})

    return <>
        <div className="col-span-full sm:col-span-1 flex items-end space-x-4">
            <FIconColorPicker
                register={register}
                errors={errors}
                icon={{
                    field: iconField,
                    rules: fields.icon.rules,
                    setValue,
                    value: watchIcon
                }}
                color={{
                    field: colorField,
                    rules: fields.color.rules,
                    setValue,
                    value: watchColor
                }}
            />
        </div>
        <div className="col-span-full sm:col-span-5">
            <FormInput register={register} errors={errors} {...fields.title} />
        </div>
        <div className="col-span-full">
            <FTextArea register={register} errors={errors} {...fields.description} />
        </div>
    </>
}